import { action } from 'typesafe-actions';
import {
  TerminalBlocksTypes,
  TerminalBlockInterface,
  BlockScheduleToggleStatus,
} from './types';

// List Terminal Blocks
export const listTerminalBlocksRequest = (payload: {
  body?: object;
  filtering?: boolean;
}) => action(TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_REQUEST, payload);
export const listTerminalBlocksSuccess = (payload: {
  terminalBlocksList: TerminalBlockInterface[];
  totalCount: number;
}) => action(TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_SUCCESS, payload);
export const listTerminalBlocksFailure = () =>
  action(TerminalBlocksTypes.LIST_TERMINAL_BLOCKS_FAILURE);

// List Terminal Blocks
export const toggleBlocksScheduleStatusRequest = (payload: {
  blockId?: string;
  blockScheduleId?: string;
}) => action(TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_REQUEST, payload);
export const toggleBlocksScheduleStatusSuccess = (payload: {
  toggleBlockScheduleStatus: BlockScheduleToggleStatus;
}) => action(TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_SUCCESS, payload);
export const toggleBlocksScheduleStatusFailure = () =>
  action(TerminalBlocksTypes.TOGGLE_BLOCK_SCHEDULE_STATUS_FAILURE);

// ToggleTerminalPanic
export const toggleTerminalPanicRequest = (payload: object) =>
  action(TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_REQUEST, payload);
export const toggleTerminalPanicSuccess = (payload: {
  toggleTerminalPanic: any;
}) => action(TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_SUCCESS, payload);
export const toggleTerminalPanicFailure = () =>
  action(TerminalBlocksTypes.TOGGLE_TERMINAL_PANIC_FAILURE);

// Create Block Schedule
export const createBlockScheduleRequest = (payload: object) =>
  action(TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_REQUEST, payload);
export const createBlockScheduleSuccess = (payload: {
  terminalBlockScheduleData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_SUCCESS, payload);
export const createBlockScheduleFailure = () =>
  action(TerminalBlocksTypes.CREATE_BLOCK_SCHEDULE_FAILURE);

// Update Block Schedule
export const updateBlockScheduleRequest = (payload: object) =>
  action(TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_REQUEST, payload);
export const updateBlockScheduleSuccess = (payload: {
  terminalBlockScheduleData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_SUCCESS, payload);
export const updateBlockScheduleFailure = () =>
  action(TerminalBlocksTypes.UPDATE_BLOCK_SCHEDULE_FAILURE);

// Delete Block Schedule
export const deleteBlockScheduleRequest = (payload: object) =>
  action(TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_REQUEST, payload);
export const deleteBlockScheduleSuccess = () =>
  action(TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_SUCCESS);
export const deleteBlockScheduleFailure = () =>
  action(TerminalBlocksTypes.DELETE_BLOCK_SCHEDULE_FAILURE);

// Update Terminal Block
export const blockScheduleGateCreateRequest = (payload: object) =>
  action(TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_REQUEST, payload);
export const blockScheduleGateCreateSuccess = (payload: {
  terminalBlockScheduleData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_SUCCESS, payload);
export const blockScheduleGateCreateFailure = () =>
  action(TerminalBlocksTypes.BLOCK_SCHEDULE_GATE_CREATE_FAILURE);

// Get Terminal Block
export const getTerminalBlockRequest = (payload: object) =>
  action(TerminalBlocksTypes.GET_TERMINAL_BLOCK_REQUEST, payload);
export const getTerminalBlockSuccess = (payload: {
  terminalBlockData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.GET_TERMINAL_BLOCK_SUCCESS, payload);
export const getTerminalBlockFailure = () =>
  action(TerminalBlocksTypes.GET_TERMINAL_BLOCK_FAILURE);

// List Terminal Blocks
export const filterTerminalBlocksRequest = (payload: object) =>
  action(TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_REQUEST, payload);
export const filterTerminalBlocksSuccess = (payload: {
  terminalBlocksList: TerminalBlockInterface[];
  totalCount: number;
}) => action(TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_SUCCESS, payload);
export const filterTerminalBlocksFailure = () =>
  action(TerminalBlocksTypes.FILTER_TERMINAL_BLOCKS_FAILURE);

// Create Terminal Block
export const createTerminalBlockRequest = (payload: object) =>
  action(TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_REQUEST, payload);
export const createTerminalBlockSuccess = (payload: {
  terminalBlockData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_SUCCESS, payload);
export const createTerminalBlockFailure = () =>
  action(TerminalBlocksTypes.CREATE_TERMINAL_BLOCK_FAILURE);

// Update Terminal Block
export const updateTerminalBlockRequest = (payload: object) =>
  action(TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_REQUEST, payload);
export const updateTerminalBlockSuccess = (payload: {
  terminalBlockData: TerminalBlockInterface;
}) => action(TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_SUCCESS, payload);
export const updateTerminalBlockFailure = () =>
  action(TerminalBlocksTypes.UPDATE_TERMINAL_BLOCK_FAILURE);

// Delete Terminal Block
export const deleteTerminalBlockRequest = (payload: object) =>
  action(TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_REQUEST, payload);
export const deleteTerminalBlockSuccess = () =>
  action(TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_SUCCESS);
export const deleteTerminalBlockFailure = () =>
  action(TerminalBlocksTypes.DELETE_TERMINAL_BLOCK_FAILURE);
